import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { GrossMarginReport, IGrossMarginReportQuery } from "models/gross-margin-report"
import FiscalCalendar from "utils/fiscal-calendar"
import Branch from "models/branch"
import Department from "models/department"


// Reports look back one month: fiscal year of last month, period 1 to last month
const { fiscalYear, period } = FiscalCalendar.lastMonth()
const fromFiscalPeriod = fiscalYear * 100 + 1
const toFiscalPeriod = fiscalYear * 100 + period

export interface GrossMarginReportSliceState {
    report: GrossMarginReport | null
    query: IGrossMarginReportQuery
    isLoading: boolean
    branches: Branch[]
    departments: Department[]
}

export const initialState: GrossMarginReportSliceState = {
    report: null,
    query: {
        fromFiscalPeriod,
        toFiscalPeriod,
    } as IGrossMarginReportQuery,
    isLoading: true,
    branches: [],
    departments: [],
}

const budgetActualsSlice = createSlice({
    name: 'budgetActuals',
    initialState,
    reducers: {
        setReport(state, { payload }: PayloadAction<GrossMarginReport>) {
            state.report = payload
        },
        setQuery(state, { payload }: PayloadAction<IGrossMarginReportQuery>) {
            state.query = payload
        },
        setIsLoading(state, { payload }: PayloadAction<boolean>) {
            state.isLoading = payload
        },
        setSearchFields(state, { payload }: PayloadAction<{
            branches: Branch[],
            departments: Department[]
        }>) {
            state.branches = payload.branches
            state.departments = payload.departments
        }
    }
})

export const {
    setReport,
    setQuery,
    setIsLoading,
    setSearchFields
} = budgetActualsSlice.actions

export default budgetActualsSlice.reducer